import * as R from 'ramda';

import React from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../../Environment';

import {
  Loading
} from '../../helpers';

import {
  Alert,
  Row,
  Col,
  Tag
} from 'antd';

const ElectronicSignatureQuery = graphql`
  query ElectronicSignatureQuery($contractId: ID!) {
    signatureState(contractId: $contractId) {
      id
      url
      state
    }
  }
`;

const ElectronicSignature = ({
  contract,
  isSigned
}) => {
  const id = R.path(['signature', 'id'], contract);

  if (R.isNil(id)) {
    return null;
  }

  const signatureMode = R.path(['signature', 'mode'], contract);
  const isUniversignUTC = R.pathEq(['signature', 'service'], 'UNIVERSIGN_UTC', contract);
  const expectedStatus = isSigned
    ? 'completed'
    : isUniversignUTC
      ? 'started'
      : 'ready';

  const getStatusColor = R.ifElse(
    R.equals(expectedStatus),
    R.always('green'),
    R.always('red')
  );

  return <div>
    <QueryRenderer
      environment={environment}
      query={ElectronicSignatureQuery}
      variables={{
        contractId: contract.id
      }}
      render={({ props, error }) => {
        if (!R.isNil(error)) {
          return <Alert
            type="error"
            description={'Une erreur est survenue.'}
          />;
        }

        if (R.isNil(props)) {
          return <Loading/>;
        }

        if (R.isNil(props.signatureState)) return (
          <Alert
            type="error"
            description={'ID de signature invalide'}
          />
        );

        const attr = (path) => R.pathOr('', path.split('.'), props.signatureState);

        return <div>
          <Row style={{ marginTop: '8px' }}>
            <Col span={6}>ID :</Col>
            <Col span={18}>{attr('id')}</Col>
          </Row>

          <Row>
            <Col span={6}>Version Universign :</Col>
            <Col span={18}>{isUniversignUTC ? 'UTC' : 'v1'}</Col>
          </Row>

          <Row>
            <Col span={6}>Statut Universign :</Col>
            <Col span={18}><Tag color={getStatusColor(attr('state'))}>{attr('state')}</Tag></Col>
          </Row>

          <Row>
            <Col span={6}>Type de signature : </Col>
            <Col span={18}>{signatureMode === 'iframe' ? 'En ligne' : 'Email'}</Col>
          </Row>

          {attr('state') !== expectedStatus && (
            <div style={{ marginTop: '12px' }}>
              <Alert
                type="error"
                description={'Le statut SPID du contrat et le statut Universign de la signature ne sont pas cohérents.'}
              />
            </div>
          )}
        </div>;
      }}
    />
  </div>;
};

export default ElectronicSignature;
